export default "__VITE_ASSET__DJZ5okQf__"